/**
 * @generated SignedSource<<92498e8f9905fd6ade33c53fadbd1948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditPageQuery$variables = {
  id: string;
};
export type PackageDateEditPageQuery$data = {
  readonly packageDate: {
    readonly end: string;
    readonly package: {
      readonly id: string;
      readonly name: string;
    };
    readonly start: string;
    readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditTabs_packageDate" | "PackageDateSidebar_packageDate">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditTabs_data">;
};
export type PackageDateEditPageQuery = {
  response: PackageDateEditPageQuery$data;
  variables: PackageDateEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supplier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flightNumber",
        "storageKey": null
      }
    ],
    "type": "FlightSegment",
    "abstractKey": null
  },
  (v4/*: any*/)
],
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageDateEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PackageDate",
        "kind": "LinkedField",
        "name": "packageDate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Package",
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageDateEditTabs_packageDate"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageDateSidebar_packageDate"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PackageDateEditTabs_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageDateEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PackageDate",
        "kind": "LinkedField",
        "name": "packageDate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Package",
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Airport",
                "kind": "LinkedField",
                "name": "defaultDepartureAirport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Airport",
                "kind": "LinkedField",
                "name": "defaultArrivalAirport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Flight",
            "kind": "LinkedField",
            "name": "flight",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceLive",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUpdating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightPrice",
                        "kind": "LinkedField",
                        "name": "lastSuccessfulUpdate",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "provider",
                        "storageKey": null
                      }
                    ],
                    "type": "Flight",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forwardSegments",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "returnSegments",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "FlightType",
                "abstractKey": "__isFlightType"
              },
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "onlyPriceChanged",
                    "value": true
                  }
                ],
                "concreteType": "FlightPriceConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightPriceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightPrice",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priceChange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualPrice",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceMessage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "history(first:10,onlyPriceChanged:true)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceOld",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v9/*: any*/)
        ],
        "concreteType": "Airport",
        "kind": "LinkedField",
        "name": "airports",
        "plural": true,
        "selections": (v6/*: any*/),
        "storageKey": "airports(first:10)"
      }
    ]
  },
  "params": {
    "cacheID": "5db7ebf9a0ee589628c9ca17e351289c",
    "id": null,
    "metadata": {},
    "name": "PackageDateEditPageQuery",
    "operationKind": "query",
    "text": "query PackageDateEditPageQuery(\n  $id: ID!\n) {\n  packageDate(id: $id) {\n    start\n    end\n    package {\n      id\n      name\n    }\n    ...PackageDateEditTabs_packageDate\n    ...PackageDateSidebar_packageDate\n    id\n  }\n  ...PackageDateEditTabs_data\n}\n\nfragment AirportSelect_data on Query {\n  airports(first: 10) {\n    id\n    name\n    code\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment FlightDetailsPrice_flight on Flight {\n  priceLive\n  isUpdating\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n  ...FlightListProvider_flight\n}\n\nfragment FlightDetails_flight on FlightType {\n  __isFlightType: __typename\n  ...FlightDetailsPrice_flight\n  forwardSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n}\n\nfragment FlightInfoEndpoint_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoFullSegment_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoSegmentInfo_segment on FlightSegment {\n  supplier\n  flightNumber\n  departDatetime\n  arrivalDatetime\n}\n\nfragment FlightInfo_segments on FlightSegment {\n  arrivalDatetime\n  departDatetime\n  duration\n  ...FlightInfoFullSegment_segment\n  ...FlightInfoEndpoint_segment\n  ...FlightInfoSegmentInfo_segment\n}\n\nfragment FlightListProvider_flight on Flight {\n  provider\n}\n\nfragment FlightPriceChangeIcon_entry on FlightPrice {\n  priceChange\n}\n\nfragment FlightPriceHistoryRow_entry on FlightPrice {\n  priceChange\n  newPrice\n  actualPrice\n  createdAt\n  status\n  serviceMessage\n  ...FlightPriceChangeIcon_entry\n}\n\nfragment FlightPriceHistoryTable_history on FlightPriceConnection {\n  edges {\n    node {\n      id\n      ...FlightPriceHistoryRow_entry\n    }\n  }\n  pageInfo {\n    total\n    ...Table_pageInfo\n  }\n}\n\nfragment FlightSearchForm_data on Query {\n  ...AirportSelect_data\n}\n\nfragment FlightSearchForm_defaultArrivalAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSearchForm_defaultDepartureAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment PackageDateAddFlightDialog_data on Query {\n  ...FlightSearchForm_data\n}\n\nfragment PackageDateAddFlightDialog_package on Package {\n  defaultDepartureAirport {\n    ...FlightSearchForm_defaultDepartureAirport\n    id\n  }\n  defaultArrivalAirport {\n    ...FlightSearchForm_defaultArrivalAirport\n    id\n  }\n}\n\nfragment PackageDateAddFlightDialog_packageDate on PackageDate {\n  id\n  start\n  end\n}\n\nfragment PackageDateEditFlightPriceHistory_flight on Flight {\n  history(first: 10, onlyPriceChanged: true) {\n    ...FlightPriceHistoryTable_history\n    pageInfo {\n      total\n    }\n  }\n}\n\nfragment PackageDateEditFlight_data on Query {\n  ...PackageDateAddFlightDialog_data\n}\n\nfragment PackageDateEditFlight_package on Package {\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageDateEditFlight_packageDate on PackageDate {\n  id\n  flight {\n    ...FlightDetails_flight\n    ...PackageDateEditFlightPriceHistory_flight\n    id\n  }\n  ...PackageDateAddFlightDialog_packageDate\n}\n\nfragment PackageDateEditMain_packageDate on PackageDate {\n  id\n  start\n  end\n  price\n  priceOld\n}\n\nfragment PackageDateEditTabs_data on Query {\n  ...PackageDateEditFlight_data\n}\n\nfragment PackageDateEditTabs_packageDate on PackageDate {\n  id\n  package {\n    ...PackageDateEditFlight_package\n    id\n  }\n  flight {\n    id\n  }\n  ...PackageDateEditMain_packageDate\n  ...PackageDateEditFlight_packageDate\n}\n\nfragment PackageDateSidebar_packageDate on PackageDate {\n  start\n  end\n  package {\n    id\n    name\n  }\n  ...EntitySidebar_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "0d1f35fe82bc193dc4e787fe164f1de8";

export default node;
